<nav aria-label="breadcrumb" class="breadcrumb"style="padding:10px;">
    <div class="container">
        <ul>
            <li class="breadcrumb-item" style="cursor:pointer;"><a routerLink="/home-one"><b style="color:white;">Home/</b></a></li>
            <li class="breadcrumb-item bread_active" aria-current="page"><b class="enimy" style="color:white;">Donation</b></li>
            <div>Donation</div>

        </ul>
    </div>
</nav>
<div id="team" class="team-area ptb-100">
    <div class="container">
        <!--<div class="section-title">
            <h4>Donattion</h4>
            <h2>Spread the  <span>Word</span></h2>
        </div>-->
        <p>
            <strong>
                By donating to the SubhaSankalpam Foundation, you directly support our efforts in
                providing fresh food to those in need.
            </strong> Your monetary contributions go towards
            sourcing fresh ingredients, maintaining distribution networks, and expanding our reach to
            serve more communities.
        </p>
        <p>
            Your monetary contributions serve as the lifeblood of our organization, empowering us to source the finest and freshest
            ingredients for our food distribution initiatives.
        </p>      <br />
        <!--<div class="team-slides">
        <owl-carousel-o [options]="teamSlides">
            <ng-template carouselSlide>
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-1.jpg" alt="team-img">
                    </div>
                    <div class="content">
                        <h3 class="title">John Smith</h3>
                        <span class="post">CEO</span>
                    </div>
                    <div class="social">
                        <ul>
                            <li><a href="#" target="_blank" class="fab fa-facebook-f"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-twitter"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-instagram"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-linkedin-in"></a></li>
                        </ul>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-2.jpg" alt="team-img">
                    </div>
                    <div class="content">
                        <h3 class="title">David Warner</h3>
                        <span class="post">Web Developer</span>
                    </div>
                    <div class="social">
                        <ul>
                            <li><a href="#" target="_blank" class="fab fa-facebook-f"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-twitter"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-instagram"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-linkedin-in"></a></li>
                        </ul>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-3.jpg" alt="team-img">
                    </div>
                    <div class="content">
                        <h3 class="title">James Andy</h3>
                        <span class="post">Back-End Developer</span>
                    </div>
                    <div class="social">
                        <ul>
                            <li><a href="#" target="_blank" class="fab fa-facebook-f"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-twitter"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-instagram"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-linkedin-in"></a></li>
                        </ul>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-4.jpg" alt="team-img">
                    </div>
                    <div class="content">
                        <h3 class="title">David Smith</h3>
                        <span class="post">Front-End Developer</span>
                    </div>
                    <div class="social">
                        <ul>
                            <li><a href="#" target="_blank" class="fab fa-facebook-f"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-twitter"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-instagram"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-linkedin-in"></a></li>
                        </ul>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-5.jpg" alt="team-img">
                    </div>
                    <div class="content">
                        <h3 class="title">John Doe</h3>
                        <span class="post">Web Developer</span>
                    </div>
                    <div class="social">
                        <ul>
                            <li><a href="#" target="_blank" class="fab fa-facebook-f"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-twitter"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-instagram"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-linkedin-in"></a></li>
                        </ul>
                    </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-6.jpg" alt="team-img">
                    </div>
                    <div class="content">
                        <h3 class="title">Olivia Smith</h3>
                        <span class="post">Photographer</span>
                    </div>
                    <div class="social">
                        <ul>
                            <li><a href="#" target="_blank" class="fab fa-facebook-f"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-twitter"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-instagram"></a></li>
                            <li><a href="#" target="_blank" class="fab fa-linkedin-in"></a></li>
                        </ul>
                    </div>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>-->

        <main id="main">

            <div class="ulockd-home-slider">
                <div class="container-fluid">

                    <div class="row">

                        <!--<div class="col-lg-2"></div>-->
                        <div class="col-lg-12">
                            <div class="layout">
                                <input name="nav" type="radio" class="nav check-radio" id="One time payment" checked="checked" />
                                <div class="page home-page">
                                    <div class="page-contents">
                                        <br />

                                        <fieldset>
                                            <legend>Amount</legend>
                                            <div class="row">
                                                <div class="col-lg-5">  <label for="fname">Indian Rupee (INR)</label></div>
                                                <div class="col-lg-7">
                                                    <div class="form__group field">
                                                        <input type="text" class="form__field" placeholder="Enter Amount" name="name" id='amount' required disabled />
                                                        <label for="amount" class="form__label">200<span style="color:red"></span></label>
                                                    </div>
                                                </div>
                                            </div>

                                        </fieldset>
                                        <br />
                                        <fieldset>
                                            <legend>Personal Details</legend>
                                            <div class="row">

                                                <div class="col-lg-12">
                                                    <br />
                                                    <div class="form__group field">
                                                        <input type="text" class="form__field" placeholder="Enter Your Name" name="name" id='name' required />
                                                        <label for="name" class="form__label"> Name<span style="color:red">*</span></label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <br />
                                                    <div class="form__group field">
                                                        <input type="text" class="form__field" placeholder="Enter Phone Number" name="name" id='number' required />
                                                        <label for="number" class="form__label"> Number<span style="color:red">*</span></label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <br />
                                                    <div class="form__group field">
                                                        <input type="text" class="form__field" placeholder="Enter Email Address" name="name" id='mail' required />
                                                        <label for="mail" class="form__label"> Email <span style="color:red">*</span></label>
                                                    </div>
                                                </div>


                                                <div class="col-lg-6">
                                                    <br />
                                                    <div class="form__group field">
                                                        <input type="text" class="form__field" placeholder="Enter Pincode" name="name" id='Pincode' required />
                                                        <label for="Pincode" class="form__label">Pincode</label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <br />
                                                    <p>
                                                        <i class="fa fa-check-square" style=" color: #0d9281;
    font-size: 20px;"></i> Enter Complete Address for Postal Communication
                                                    </p><br />
                                                    <div class="form__group field">
                                                        <input type="text" class="form__field" placeholder="Enter Address" name="name" id='addresss' required />
                                                        <label for="addresss" class="form__label">Address</label>
                                                    </div>
                                                    <br />
                                                </div>
                                                <div class="col-lg-12">
                                                    <br />
                                                    <div class="form__group field">
                                                        <select name="cars" id="cars">
                                                            <option value="volvo">Andhra Pradesh</option>
                                                            <option value="saab">Telangana</option>
                                                            <option value="mercedes">Assam</option>
                                                            <option value="audi">Andaman Nicobar</option>
                                                        </select>
                                                        <label for="state" class="form__label">Select Your State<span style="color:red">*</span></label>
                                                        <p></p>
                                                    </div>
                                                    <br />
                                                </div>
                                                <div class="col-lg-12">
                                                    <br />
                                                    <div class="form__group field">
                                                        <select name="cars" id="cars">
                                                            <option value="annadanam">Annadanam</option>
                                                            <option value="water_purifiers">Water Purifiers</option>
                                                            <option value="birthday">Birthday</option>
                                                            <option value="anniversary">Anniversary</option>
                                                        </select>
                                                        <label for="state" class="form__label">On Occation type <span style="color:red">*</span></label>
                                                        <p></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <br />

                                        <!--<div class="row">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">-->
                                        <!-- HTML !-->
                                        <!--<button class="button-29" role="button">Proceed</button>
        </div>
        <div class="col-lg-3"></div>
    </div>-->
                                        <div>
                                            <form  (ngSubmit)="onSubmit()">
                                                <!-- Your form controls here -->

                                                <button type="submit" class="button-29">Submit</button>
                                            </form>

                                            <!-- Embed the short URL within an iframe -->
                                           

                                        </div>
                                        <!--------------->

                                    </div>
                                </div>
                                <label class="nav" for="One time payment">
                                    <span>
                                        <i class="fa fa-check-square"></i>    Monthly Payment
                                    </span>
                                </label>

                                <!--<input name="nav" type="radio" class="about-radio" id="about" />
                <div class="page about-page">

                </div>
                <label class="nav" for="about">
                    <span>
                        Monthly Payment
                    </span>
                </label>-->


                            </div>
                            <div class="col-lg-3"></div>
                        </div>
                        <!--<div class="col-lg-2"></div>-->
                    </div>



                    <!---------------------------new-->
              
                </div>
            </div>
        </main>
    </div>
    <div class="shape1"><img src="assets/img/shape1.png" alt="image"></div>
</div>
<style>
    @media only screen and (max-width:600px){
        label.nav {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-bottom: 2px solid #008cb3;
            background: #ecf0f1;
            -webkit-user-select: none;
            user-select: none;
            transition: background 0.4s, padding-left 0.2s;
            padding-left: 0;
            border-radius: 50px 0px;
            margin-left: 3rem;
            width: 150%;
        }
        fieldset {
            padding: 9px;
            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            background-color: white;
            border-radius: 5px;
            margin-bottom: 5%;
        }
        legend {
            font-size: 15px;
            padding: 6px;
            width: 55%;
            text-align: center;
            background-color: #008cb3;
            border-radius: 50px 0;
            margin-bottom: 5%;
            margin-top: -8%;
            color: #f5eaea;
            border: 1px solid #008cb3;
        }
        .form__field : placeholder-shown ~ .form__label{
            font-size: 1rem;
            cursor: text;
            top: 20px;
            margin-top: 5%;
            padding: 0px;
        }
        .form__group {
            position: relative;
            padding: 15px 0 0;
            margin-top: -19px;
            width: 100%;
            margin-bottom: 5%;
        }
        .layout {
            display: grid;
            height: 100%;
            overflow: hidden;
            grid-template-rows: 50px 1fr;
            grid-template-columns: 1fr 1fr 1fr;
            width: 108%;
            margin-left: -4%;
        }
        .button-29 {
            align-items: center;
            -webkit-appearance: none;
            appearance: none;
            background-image: linear-gradient(to right, #006ea5, #00cad0);
            border: 0;
            border-radius: 6px;
            box-shadow: rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, rgba(58, 65, 111, 0.5) 0 -3px 0 inset;
            box-sizing: border-box;
            color: #fff;
            cursor: pointer;
            display: inline-flex;
            height: 48px;
            justify-content: center;
            line-height: 1;
            list-style: none;
            overflow: hidden;
            padding-left: 16px;
            padding-right: 16px;
            position: relative;
            text-align: left;
            text-decoration: none;
            transition: box-shadow 0.15s, transform 0.15s;
            user-select: none;
            -webkit-user-select: none;
            touch-action: manipulation;
            white-space: nowrap;
            will-change: box-shadow, transform;
            font-size: 18px;
            font-size: 20px;
             margin: 0%; 
            width: 100%;
        }
    }
</style>

